import { render, staticRenderFns } from "./editOwnerRepair.vue?vue&type=template&id=4812e8a4"
import script from "./editOwnerRepair.vue?vue&type=script&lang=js"
export * from "./editOwnerRepair.vue?vue&type=script&lang=js"
import style0 from "./editOwnerRepair.vue?vue&type=style&index=0&id=4812e8a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports